<script lang="ts">
  const { children } = $props()
</script>

<svelte:head>
  <link
    rel="preload"
    href="/fonts/libre-baskerville.woff2"
    crossorigin="anonymous"
    as="font"
    type="font/woff2"
  />
</svelte:head>

{@render children?.()}
